// Module
var code = `<form name="\$ctrl.form">
  <table class="table table--last-column-to-right" ng-if="\$ctrl.holidays">
    <thead>
    <tr>
      <th class="no-column-header">No</th>
      <th>Name</th>
      <th>Date</th>
      <th>Type</th>
      <th>Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="item in \$ctrl.holidays" ng-form name="\$ctrl['form_' + \$index]">
      <td>{{\$index + 1}}.</td>

      <!-- Existing item -->
      <td ng-if="!item.dirty">
        {{item.name}}
      </td>
      <td ng-if="!item.dirty">
        {{item.date | prettyDate}}
      </td>
      <td ng-if="!item.dirty">
        {{item.type | prettyEnum}}
      </td>

      <!-- New item-->
      <td ng-if="item.dirty">
        <input class="holiday-list__input"
               type="text"
               required
               minlength="1"
               maxlength="100"
               ng-model="item.name" />
      </td>
      <td ng-if="item.dirty">
        <date ng-required="true"
              validate-date="gte:posting-date"
              class="holiday-list__input"
              ng-model="item.date"></date>
      </td>
      <td ng-if="item.dirty">
        Holiday
      </td>

      <!-- Actions -->
      <td class="table__actions">
        <button ng-if="!item.dirty"
                class="btn btn-danger pull-right"
                type="button"
                ng-click="\$ctrl.removeHoliday(\$index)">Remove</button>
        <button ng-if="!item.dirty && \$ctrl.updateEnabled"
                class="btn btn-warning pull-right"
                type="button"
                ng-click="\$ctrl.editHoliday(\$index)">Edit</button>
        <button ng-if="item.dirty"
                class="btn btn-danger pull-right"
                type="button"
                ng-disabled="\$ctrl.isSaveDisabled(\$index)"
                ng-click="\$ctrl.cancelHolidayForm(\$index)">Cancel</button>
        <button ng-if="item.dirty"
                class="btn btn-success pull-right save-button"
                type="button"
                ng-disabled="\$ctrl.isSaveDisabled(\$index)"
                ng-click="\$ctrl.saveHoliday(\$index)">Save</button>
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="5" class="holiday-list__add-new-column">
        <button class="btn btn-success" type="button" ng-click="\$ctrl.addHoliday()">
          Add
        </button>
      </td>
    </tr>
    </tfoot>
  </table>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/holiday/holiday-table.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;